export enum OfferStatusId {
    LIVE = 1,
    DECLINED = 2,
    CANCELED = 3,
    ACCEPTED = 4,
    PENDING = 5,
    EXPIRED = 6,
    NOT_POSSIBLE = 7,
    COMPLETED = 8,
    BOUNCED = 9,
    BIZ_COUNTER = 10,
    CLOSED = 11,
    RESERVED = 12,
    NEW_OFFER = 13
}

export enum GQL_OfferStatus {
    "LIVE_OFFER"= 1,
    "DECLINED"= 2,
    "CANCELED"= 3,
    "ACCEPTED"= 4,
    "PENDING"= 5,
    "EXPIRED"= 6,
    "NOT_POSSIBLE"= 7,
    "COMPLETED"= 8,
    "BOUNCED"= 9,
    "BIZ_COUNTER"= 10,
    "CLOSED"= 11,
    "RESERVED"=12,
    "NEW_OFFER"=13
}

export enum GQL_Offer_from {
    "EDGE"= 2
}


export const OfferStatusMap = {
  [OfferStatusId.LIVE]: 'Live Offer',
  [OfferStatusId.DECLINED]: 'Declined Offer',
  [OfferStatusId.CANCELED]: 'Canceled Offer',
  [OfferStatusId.ACCEPTED]: 'Accepted Offer',
  [OfferStatusId.PENDING]: 'Pending',
  [OfferStatusId.EXPIRED]: 'Expired Offer',
  [OfferStatusId.BIZ_COUNTER]: 'Counter Offer',
  [OfferStatusId.NOT_POSSIBLE]: 'Not Possible',
  [OfferStatusId.COMPLETED]: 'Offer Accepted & Booked',
  [OfferStatusId.BOUNCED]: 'Offer Booked & Bounced',
  [OfferStatusId.CLOSED]: 'Accepted',
  [OfferStatusId.RESERVED]: 'Reserved'
}

export enum OfferChangeReasonId {
    CONFIRMING_ADDITIONAL_INFORMATION = 0, //pending reason
    WAITING_ON_NEW_APPOINTMENT = 1, //pending reason
    TRUCK_NO_LONGER_AVAILABLE = 2, // cancel reason
    APPOINTMENT_CONFLICT = 3, //decline reason
    DOES_NOT_MEET_LOAD_REQUIREMENTS = 4, //decline reason
    OTHER = 6,
    TRUCK = 7, //decline reason
    RATE = 8 //declince reason
}

export interface OffersFilterType {
    LoadNumbers: Array<number>;
    OfferStatuses?: Array<OfferStatusId>;
    ColumnToSort: string;
    SortDirection: string;
    PageSize: number;
    PageNumber: number;
    CarrierId?: number;
    UserId?: number;
}

export interface OfferType {
    id: number;
    amount: number;
    bizCounterAmount: number | null;
    originCity?: string;
    originState?: string;
    originEarliest?: string;
    originLatest?: string;
    originCityIANATimeZoneName?: string;
    originGeocode?: string;
    destinationCity?: string;
    destinationState?: string;
    destinationEarliest?: string;
    destinationLatest?: string;
    destinationCityIANATimeZoneName?: string;
    destinationGeocode?: string;
    loadNumber: number;
    loadStatus?: string;
    status: OfferStatusId;
    changeReason: OfferChangeReasonId;
    enteredByUserId?: number;
    carrierId?: number;
    carrierName?: string;
    carrierCode?: string;
    updatedOn: string;
    expiration: string;
    timerStart: string;
    updateCount?: number;
    topSpend?: number;
}

export interface OfferHistoryType {
    id: number;
    enteredByUserId: number;
    amount: number;
    bizCounterAmount: number;
    from: number;
    on: string
    status: OfferStatusId;
    changeReason: OfferChangeReasonId;
    enteredBy: {
        keypointUserCode: string;
        firstName: string;
        lastName: string;
    }
}
